<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="3">
          <h3>{{ name }}</h3>
        </b-col>
        <b-col>
          <!-- <b-button @click="DownloadXlsx()"> Ladda ned som Excel-fil</b-button>
                &nbsp; -->
          <b-button @click="Edit()">Redigera</b-button>
        </b-col>
      </b-row>

      <hr />
      <!-- <b-table v-if="recs" :items="recs"
          :sortable="true"
          :small="true">

      </b-table> -->
      <table v-if="logicset && !editMode" class="logicsettable">
        <thead>
          <tr>
            <th v-for="c in GetCols(true)" :key="c.id">{{ c.caption }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in recs" :key="r.recid">
            <td v-for="(c, index) in GetCols(true)" :key="index">
              {{ r[c.field] }}
            </td>
          </tr>
        </tbody>
      </table>
      <logicsetedit v-if="editMode"></logicsetedit>

      <tableedit v-if="editMode" v-bind:recs="recs" v-bind:cols="GetCols(true)" v-bind:readonly="!editMode"></tableedit>
      <!-- <b-modal v-model="editMode" @ok="editMode = false" modal-class="modal-fullscreen">
        
      </b-modal>       -->
    </b-card>
  </div>
</template>
<script>
import tableedit from "./tableedit";
import logicsetedit from "./logicsetedit";
import { Api } from "../../lib/api";
const api = new Api();

import VueRouter, { RouteConfig } from 'vue-router';
const router = new VueRouter();

export default {
  name: "logicset",
  props: { name: String, logictype: String },
  components: { tableedit, logicsetedit },
  data() {
    return {
      logicset: null,
      recs: [],
      editMode: false
    };
  },
  created() {
    this.GetData();
  },
  watch: {
    name: function () {
      this.GetData();
    },
  },
  methods: {
    GetCols(onlyWithData) {
      if (!this.logicset)
        return [];
      var res = this.logicset.columns.filter(x => x.field != 'TenantCode');
      //TODO: Add other banned columns in filter
      if (!onlyWithData)
        return res;

      return res.filter(x => x.hasData);
    },
    GetData() {
      if (this.name && this.logictype) {
        var p = api.params({
          LogicTypeName: this.logictype,
          LogicSet: this.name,
        });
        //const url = "/api/apiConfiguration/GetLogicSet?";
        const url = "/api/Configuration/GetLogicSet?";
        api.get(url + p).then((result) => {
          this.logicset = result.data;
          var res = result.data;
          var recs = [];
          for (var i = 0; i < res.records.length; i++) {
            var it = res.records[i];
            var r = { recid: it.recid };
            for (var x = 0; x < res.columns.length; x++) {
              var v = it.values[x];
              var colName = res.columns[x].field;
              if (v != null && v != undefined && v != "") {
                if (v.v != undefined && v.v != null) r[colName] = v.v;
                if (v.l != undefined && v.l != null) {
                  r[colName] = v.l.text; //OBS! Måste kollas
                }
                if (r[colName])
                  res.columns[x].hasData = true;
              }
            }
            recs.push(r);
          }
          this.recs = recs;
        });
      }
    },
    DownloadXlsx() {
      alert('Nedladdningsfunktion ej implementerad ännu!');
    },
    Edit() {
      //TODO: Kolla behörighet
      //this.editMode = !this.editMode;

      //BOrde vara på egen sida
      //router.push({ name: 'home', params: { logicsetname: '123', logictype: 'type' } });
      this.$router.push({ name: 'logicsetedit', params: { logicsetname: this.name, logictype: this.logictype } });
    }
  },
};
</script>
<style scoped>
table,
th,
td {
  border: 1px solid black;
}

.rescolumn {
  background-color: gray
}

.modal-fullscreen .modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}</style>